<template>
  <div id="data-list-list-view">
    <vs-table
      ref="table"
      :data="currentCourses"
    >
      <template slot="thead">
        <vs-th sort-key="Name">{{$t('Course')}}</vs-th>
        <vs-th sort-key="Provider">{{$t('Code')}}</vs-th>
        <vs-th sort-key="Code">{{$t('Start')}}</vs-th>
        <vs-th sort-key="Category">{{$t('End')}}</vs-th>
        <vs-th>{{$t('Action')}}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
          >
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.Course.Name }}</p>
            </vs-td>
            <vs-td>
              <p
                class="product-name font-medium truncate"
              >
                {{ tr.ClassNo}}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.StartDate }}
              </p>
            </vs-td>
            <vs-td>
              <p
                class="product-name font-medium truncate"
              >
                {{ tr.EndDate }}
              </p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EyeIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="ViewCourse(tr)"
              />
            </vs-td>
          </tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>
<script>
import moduleTrainee from "@/store/user/trainee/moduleTrainee.js";

export default {
    data()
    {
        return{
            itemsPerPage:10
        }
    },
    methods:
    {
        ViewCourse(course)
        {
             this.$router.push({name:"CourseDetail",params: { ID: course.Course.ID}})
        }
    },
    computed:
    {
        currentCourses() {

          
           if(this.$route.params.ID==1)
           {
             if(this.$acl.check("trainee"))
             
                return this.$store.state.traineeList.home.CurrentCourses;
              else
                 return this.$store.state.customerList.homeData.CurrentCourses;
           }
           else
           {
              if(this.$acl.check("trainee"))
                return this.$store.state.traineeList.home.ObtainCourses;
              else
                return this.$store.state.customerList.homeData.ObtainCourses;
           }
       },
    },
    created()
    {
      if (!moduleCustomer.isRegistered) {
      this.$store.registerModule("customerList", moduleCustomer);
      moduleCustomer.isRegistered = true;
    }
         if (!moduleTrainee.isRegistered) {
            this.$store.registerModule("traineeList", moduleTrainee);
            moduleTrainee.isRegistered = true;
        }
    }
};
</script>


<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
